import { lazy } from 'react';

/**
 * React.lazy helper for modules that use named exports.
 * CRA code-splits on dynamic import(); keep heavy pages out of the main chunk.
 */
export const lazyNamed = (importer, exportName) =>
  lazy(() =>
    importer().then((mod) => {
      const Component = mod[exportName];
      if (!Component) {
        throw new Error(`lazyNamed: missing export "${exportName}"`);
      }
      return { default: Component };
    })
  );

/** React.lazy for default-export pages. */
export const lazyDefault = (importer) => lazy(importer);

/** Fire-and-forget chunk download (hover / route match prefetch). */
export const prefetchImport = (importer) => {
  try {
    const result = importer();
    if (result && typeof result.catch === 'function') {
      result.catch(() => {});
    }
  } catch {
    // Prefetch must never break navigation.
  }
};
